import React from 'react';
import styled from 'styled-components';
import { string, node } from 'prop-types';

const OrangeLink = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  background-color: ${({ type }) =>
    (type === 'primary' ? '#f78323' : 'white')};
  color: ${({ type }) => (type === 'primary' ? 'white' : '#f78323')};
  border-radius: 100px;
  border: solid 1px #f78323;
  line-height: 1.5;
  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : null)}
  box-sizing: border-box;
  padding: ${({ big }) => (big ? '12px 30px;' : '8px 16px;')};
  font-size: ${({ big }) => (big ? '16px;' : '14px;')};
  margin-bottom: ${({ marketing }) => (marketing ? '30px' : '0px')};
  @media (min-width: 1000px) {
    font-size: 16px;
    padding: 12px 30px;
    display: inline-block;
    cursor: pointer;
  }
`;

const OrangeButton = props => (
  <OrangeLink {...props}>{props.children}</OrangeLink>
);

OrangeButton.propTypes = {
  children: node.isRequired,
  type: string,
};

OrangeButton.defaultProps = {
  type: 'primary',
};

export default OrangeButton;
